import { RateIndicator } from "../../types/enums";
import { ArrowIcon } from "../images/ArrowIcon";
import { ReuseTooltip } from "./ReuseTooltip";
import { Stack, Typography } from "@mui/material";
import { formatDateRange } from "../../utils/formatDateRange";

export const indicatorMapper: Record<
  RateIndicator,
  { rotate: string; color: string; change?: number; changed_at?: string }
> = {
  up: { rotate: "0", color: "#1F865B" },
  down: { rotate: "90", color: "#B43600" },
};

export const RateIndicatorIcon = ({
  indicatorRate,
  showTooltip = true,
  indicatorChange,
  indicatorChangeAt,
}: {
  indicatorRate?: RateIndicator;
  showTooltip?: boolean;
  indicatorChange?: number;
  indicatorChangeAt?: string;
}) => {
  if (!indicatorRate) return null;

  return (
    <ReuseTooltip
      placement="top"
      text={
        showTooltip && (
          <Stack>
            <Stack flexDirection="row" gap="4px">
              <Typography variant="body2" fontWeight={600}>
                Last update:
              </Typography>
              <Typography variant="body2">
                {formatDateRange(indicatorChangeAt ?? "", true)}
              </Typography>
            </Stack>
            <Stack flexDirection="row" gap="4px">
              <Typography variant="body2" fontWeight={600}>
                Change:
              </Typography>
              <Typography variant="body2">
                {indicatorChange && indicatorChange > 0
                  ? `+${indicatorChange}`
                  : indicatorChange}
                %
              </Typography>
            </Stack>
          </Stack>
        )
      }
      hideChildren={false}
    >
      <ArrowIcon
        style={indicatorRate && showTooltip ? { cursor: "pointer" } : undefined}
        color={indicatorMapper[indicatorRate].color}
        rotate={indicatorMapper[indicatorRate].rotate}
      />
    </ReuseTooltip>
  );
};
